export const isRenderer = (): boolean => {
  // Check if process.type is 'renderer'
  if (typeof process !== 'undefined' && process.type === 'renderer') {
    return true;
  }

  // Fallback: Check if window exists (renderer processes have window)
  if (typeof window !== 'undefined') {
    return true;
  }

  // Default to false for main process or non-Electron environments
  return false;
};
